import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "@/app/App";
import { AppProviders } from "@/app/AppProviders";
import { env } from "@/config/env";
import "@/styles/theme.css";
import "@/styles/index.css";

// Retire the legacy network-intercepting service worker so Axios requests are
// never served by a stale offline cache from an earlier deployment.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.getRegistrations().then(async registrations => {
      await Promise.all(registrations.filter(registration =>
        registration.active?.scriptURL.endsWith('/sw.js')).map(registration => registration.unregister()));
      if ('caches' in window) {
        await Promise.all((await caches.keys()).filter(name => /^evzone-v\d+$/.test(name)).map(name => caches.delete(name)));
      }
    });
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Application root element #root was not found.");
}

const Router = env.routerMode === "hash" ? HashRouter : BrowserRouter;

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <Router>
        <App />
      </Router>
    </AppProviders>
  </StrictMode>,
);
